module.exports = __webpack_public_path__ + "static/media/loading.25d2e2a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/loading-v2/loading.svg
// module id = 367
// module chunks = 0